export default __webpack_public_path__ + "static/media/frame-elder.47c50b4c.png";